<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="addNewDataSidebar = false"
      :title="titleSideBar">
      <formCadastro slot="form" @cancel="addNewDataSidebar = false" @concluido="concluido" :sideBar="true"
        :dados="dadosSideBar" :contadorRender="contadorRender"></formCadastro>
    </add-new-data-sidebar>

    <vs-table noDataText="Nenhum Item Encontrado" class="tablePrincipal" ref="table" multiple v-model="selected"
      pagination :max-items="itemsPerPage" search :data="itens">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="inativar">
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="reativar">
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="reordenar">
                <span>Reordenar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>
                  <downloadexcel :data="selected" :fields="colunas" name="Caixas.xls" type="xls">Exportar
                  </downloadexcel>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium">
              <span class="mr-2">Filtrar por:</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="buscaDados('ativo')">
                <span>Ativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="buscaDados('inativo')">
                <span>Inativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="buscaDados('todos')">
                <span>Todos</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-------------- START FILTRO POR VALOR -------------->
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium">
              <span class="mr-2">Valores</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu class="p-0">
              <div class="vals-wrapper w-80 p-6">
                <div class="mb-4 flex-none">
                  <input v-model="filterSearch" placeholder="Buscar valor..."
                    class="w-full px-3 py-1.5 p-2 rounded-full border border-gray-100 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-primary" />
                </div>

                <div class="vals-list pr-1.5">
                  <label v-for="val in filteredFilterValues" :key="String(val)"
                    class="block mb-1.5 cursor-pointer select-none">
                    <input type="checkbox" :value="val" v-model="selectedFilterValues" @change="aplicarFiltros"
                      class="align-middle" />
                    <span class="ml-2 align-middle">{{ formatarValorMonetario(val) }}</span>
                  </label>

                  <div v-if="filterValues.length === 0" class="text-gray-400 text-sm">Nenhum valor</div>
                </div>

                <div class="flex justify-between items-center gap-2 mt-3 flex-none">
                  <div class="text-sm text-gray-500">
                    {{ selectedFilterValues.length }} selecionado(s)
                  </div>
                  <div>
                    <vs-button @click="limparFiltros" size="small" type="flat">Limpar</vs-button>
                  </div>
                </div>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ START ADD NOVO Caixa ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar({})">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Adicionar Item</span>
          </div>

          <div>
            <span :style="{ color: oddColor }">
              Total em % odd: {{ totalOdd }}
            </span>
          </div>
        </div>
        <!------------ END ADD NOVO Caixa ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ itens.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="sku">SKU</vs-th>
        <vs-th sort-key="nomeItem">Nome</vs-th>
        <vs-th sort-key="cor">Imagem</vs-th>
        <vs-th sort-key="odd">Odd</vs-th>
        <vs-th sort-key="cor">Valor</vs-th>
        <vs-th sort-key="cor">Cor</vs-th>
        <vs-th sort-key="cor">Ordenação</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.produto && tr.produto.sku ? tr.produto.sku : '---' }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.nomeItem }}</p>
            </vs-td>
            <vs-td>
              <img :src="tr.imagem" width="100" />
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.odd }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ formatarValorItem(tr.valorIntangivel, tr.valor) }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.corHexa }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.ordenacao }}</p>
            </vs-td>
            <vs-td>
              <vs-chip :color="getStatusColor(tr.deletedAt)" class="product-order-status">{{
                getStatusString(tr.deletedAt) }}</vs-chip>
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <div class="vx-col">
                  <vs-button v-tooltip="'Detalhes da Caixa'" radius color="dark" type="gradient" icon-pack="feather"
                    icon="icon-search" class="d-inline" @click="opemModal(tr.idItem)"></vs-button>
                </div>
                <div class="vx-col">
                  <vs-button v-tooltip="'Editar Caixa'" radius color="success" type="gradient" icon-pack="feather"
                    icon="icon-edit" class="d-inline" @click="openSideBar(tr)"></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Caixa ------------>
    <ModalInfo :modalSelecionado="modalSelecionado" :popupActive="popupActive" :title="`Dados do ${entidade}`"
      @close="popupActive = false"></ModalInfo>

    <!------------ END INFORMAÇÕES DO Caixa ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../../../Includes/SideBar";
import service from "./../../../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "./../../../../components/ModalInfo";
import formCadastro from "./FormCaixaItem.vue";
import jwt from "jsonwebtoken";

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    formCadastro,
    ModalInfo,
  },
  props: ["subjectPermission"],
  data() {
    return {
      idEmpresa: null,
      isAdmin: false,
      dadosSideBar: {},
      controllerGeral: "CaixasItens",
      formSideBar: "CaixaItens",
      entidade: "Item",
      titleSideBar: "Adicionar Item",
      popupActive: false,
      modalSenha: false,
      modalSelecionado: [],
      itemAlteracao: null,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 100,
      isMounted: false,
      addNewDataSidebar: false,
      contadorRender: 0,
      senha: null,
      originalItens: [],
      filterValues: [],
      filterSearch: '',
      selectedFilterValues: [],
    };
  },
  computed: {
    totalOdd() {
      return this.itens
        .filter((item) => item.deletedAt === null)
        .reduce((sum, item) => sum + parseFloat(item.odd || 0), 0);
    },
    oddColor() {
      if (this.totalOdd > 100) return "red";
      if (this.totalOdd < 100) return "blue";
      return "gray";
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    filteredFilterValues() {
      if (!this.filterSearch) return this.filterValues;
      const s = this.filterSearch.toLowerCase();
      return this.filterValues.filter(v => this.formatarValorMonetario(v).toLowerCase().includes(s));
    },

  },
  methods: {
    async reordenar() {
      this.$vs.loading();
      try {
        const objSend = { idCaixa: this.$route.params.idCaixa };

        await service.put("CaixasItens", "AtualizarOrdenacao", objSend);

        this.$vs.notify({
          position: "top-center",
          title: "Sucesso",
          text: "Itens reordenados com sucesso!",
          color: "success",
        });

        this.buscaDados();
      } catch (e) {
        console.error(e);
        this.$vs.notify({
          position: "top-center",
          title: "Erro",
          text: "Falha ao reordenar os itens",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    formatarValorMonetario(v) {
      if (v === null || v === undefined) return '---';
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    montarListaDeFiltros() {
      const set = new Set();
      this.originalItens.forEach(item => {
        let v = item.valor;
        if (v === null || v === undefined) {
          set.add(null);
        } else {
          const n = Number(v);
          set.add(Number.isNaN(n) ? String(v) : n);
        }
      });
      const arr = Array.from(set);
      arr.sort((a, b) => {
        if (a === null) return 1;
        if (b === null) return -1;
        const na = Number(a), nb = Number(b);
        if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
        return String(a).localeCompare(String(b));
      });
      this.filterValues = arr;
      this.selectedFilterValues = this.selectedFilterValues.filter(s => this.filterValues.includes(s));
    },
    aplicarFiltros() {
      if (!this.selectedFilterValues || this.selectedFilterValues.length === 0) {
        this.itens = [...this.originalItens];
        return;
      }

      this.itens = this.originalItens.filter(item => {
        const v = (item.valor === null || item.valor === undefined) ? null : Number(item.valor);
        return this.selectedFilterValues.some(sel => {
          if (sel === null) return v === null;
          return v === sel;
        });
      });
    },
    limparFiltros() {
      this.selectedFilterValues = [];
      this.filterSearch = '';
      this.itens = [...this.originalItens];
    },

    formatarValorItem(valorIntangivel, valor) {
      if (valorIntangivel == true) return "Valor Intangivel";
      else {
        var retorno = this.$options.filters.currency(valor);
        return retorno;
      }
    },
    verificaAdmin() {
      const token = localStorage.getItem("user-token");
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == "Super User") this.isAdmin = true;
      }
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idItem);
        });
        service
          .post(this.controllerGeral, "Inativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro inativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idItem);
        });
        service
          .post(this.controllerGeral, "Reativar", { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro reativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    buscaDados(filtrarpor = "todos") {
      this.selected = [];
      this.$vs.loading();

      var objSend = {
        status: filtrarpor,
        idCaixa: this.$route.params.idCaixa,
      };

      service
        .post(this.controllerGeral, "Listar", objSend)
        .then((res) => {
          this.itens = res.data.map(item => {
            return {
              ...item,
              sku: item.produto && item.produto.sku ? item.produto.sku : '---'
            };
          });
          //this.itens = res.data;
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != "createdAt" &&
                element != "updatedAt" &&
                element != "deletedAt" &&
                element.indexOf("id") != 0
              ) {
                this.colunas[element] = element;
              }
            });
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Nenhum Registro Encontrado",
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    buscaDados(filtrarpor = "todos") {
      this.selected = [];
      this.$vs.loading();

      const objSend = {
        status: filtrarpor,
        idCaixa: this.$route.params.idCaixa,
      };

      service
        .post(this.controllerGeral, "Listar", objSend)
        .then((res) => {
          this.originalItens = res.data.map(item => ({
            ...item,
            sku: item.produto && item.produto.sku ? item.produto.sku : '---'
          }));

          this.itens = [...this.originalItens];

          this.colunas = {};
          if (this.itens[0]) {
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element !== "createdAt" &&
                element !== "updatedAt" &&
                element !== "deletedAt" &&
                element.indexOf("id") !== 0
              ) {
                this.colunas[element] = element;
              }
            });
          }
          this.montarListaDeFiltros();

          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Nenhum Registro Encontrado",
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idItem == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
      this.contadorRender = this.contadorRender + 1;
    },
    openModalSenha(cod) {
      this.itemAlteracao = {};
      this.modalSenha = true;
      this.itemAlteracao = this.itens.find((x) => x.idItem == cod);
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idItem == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != "createdAt" &&
          element != "updatedAt" &&
          element != "deletedAt" &&
          element.indexOf("id") != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.addNewDataSidebar = false;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
    this.verificaAdmin();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }

  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }

  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }

  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }

  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }

  .td-check {
    visibility: hidden;
  }
}

.vals-wrapper {
  display: flex;
  flex-direction: column;
  max-height: 260px;
}

.vals-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}


#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
